import createStyleForBackgroundImage from '@/helper/createStyleForBackgroundImage';

function RealizationCard(props: {
  title: string;
  imageUrl: string;
  id: number;
}) {
  const textClass = 'font-bold text-[25px] text-inherit';

  return (
    <div
      className="relative flex flex-col justify-end items-start h-[434px] mb-8"
      style={createStyleForBackgroundImage(props.imageUrl)}
      key={props.id}
    >
      <div
        onClick={() => window.location.assign('/realizations/' + props.id)}
        className="absolute -bottom-4 lg:-bottom-8 left-0 w-[80%] h-[80px] flex flex-col justify-center gap-2 cursor-pointer bg-default hover:bg-secondary p-4 lg:p-8 text-defaultDark hover:text-default transition-all duration-300"
      >
        <div className={textClass}>{props.title}</div>
      </div>
    </div>
  );
}

export default RealizationCard;
